import {
  AfterViewInit,
  Component,
  ContentChild,
  EventEmitter,
  HostListener,
  inject,
  Input,
  Output,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { SaveableFormComponent } from './saveable-form.component';
import { BaseModel } from '../../models/basemodel';
import { LaddaModule } from 'angular2-ladda';
import {
  AppDialogRef,
  AppDialogService,
  AppDialogSize,
} from '../../services/app-dialog.service';

_('save');
_('cancel');
_('close');
_('confirm_leave_page');
@Component({
  selector: 'app-model-modal',
  templateUrl: './app-model-modal.component.html',
  imports: [LaddaModule, TranslatePipe, TranslatePipe],
})
export class AppModelModalComponent<
  T extends BaseModel,
> implements AfterViewInit {
  @Input() title!: string;

  @Input() editable = false;

  @Input() loading = false;

  @Output() saveEvent = new EventEmitter<void>();

  @Input() secondaryActionText?: string = undefined;

  @Input() secondaryActionEnabled = true;

  @Output() secondaryAction = new EventEmitter<void>();

  @ViewChild('modal', { static: true }) modal!: TemplateRef<unknown>;

  // non-static as this will be changing depending on ng-content. -> it will be available at ngAfterViewInit
  @ContentChild('form', { static: false })
  childForm!: SaveableFormComponent<T>;

  isSaveValid = false;

  modalRef?: AppDialogRef;

  private shouldHide = false;

  private modalService = inject(AppDialogService);
  private translateService = inject(TranslateService);

  @HostListener('window:beforeunload', ['$event'])
  preventTabClose(event: BeforeUnloadEvent) {
    if (!this.canClose()) {
      event.returnValue = this.translateService.instant('confirm_leave_page');
      event.preventDefault();
    }
  }

  save(): void {
    this.saveEvent.emit();
  }

  show(size: AppDialogSize = 'lg'): AppDialogRef {
    this.shouldHide = false;
    this.modalRef = this.modalService.open(this.modal, {
      size,
      dismissableMask: !this.editable,
      closeOnEscape: !this.editable,
    });
    return this.modalRef;
  }

  hide(): void {
    if (this.modalRef) {
      this.shouldHide = true;
      this.modalRef.close();
    }
  }

  canClose(): boolean {
    return (
      this.shouldHide ||
      !this.editable ||
      this.childForm?.form?.pristine === true
    );
  }

  ngAfterViewInit() {
    if (this.childForm != null) {
      this.isSaveValid = this.childForm.form.valid;
      this.childForm.validityChange.subscribe((status) => {
        this.isSaveValid = status;
      });
    } else {
      this.isSaveValid = true;
    }
  }
}
